// Sua may hang nam
import sm1 from "./../../../assets/images/suaMay/1.png";
import sm2 from "./../../../assets/images/suaMay/2.png";
import sm3 from "./../../../assets/images/suaMay/3.png";
import sm4 from "./../../../assets/images/suaMay/4.png";
import sm5 from "./../../../assets/images/suaMay/5.png";

// Ho tro nhap hoc
import ht1 from "./../../../assets/images/HoTro/1.jpeg";
import ht2 from "./../../../assets/images/HoTro/2.jpeg";
import ht3 from "./../../../assets/images/HoTro/3.jpeg";
import ht4 from "./../../../assets/images/HoTro/4.jpeg";
import ht5 from "./../../../assets/images/HoTro/5.jpeg";

const events = [
  {
    name: `SuaMay`,
    title: `Sự kiện sửa máy hàng năm`,
    desc: `Là hoạt động vô cùng quan trọng, được SIC tổ chức diễn ra hàng năm sửa chữa máy tính miễn phí cho sinh viên- cán bộ giáo viên bao gồm các hoạt động thiết thực như:
        Hỗ trợ vệ sinh và nâng cấp máy tính.
        Tư vấn máy tính miễn phí.
        Cài đặt windows, phần mềm,...`,
    images: [sm1, sm2, sm3, sm4, sm5],
  },
  {
    name: `HoTro`,
    title: `Hỗ trợ tân sinh viên nhập học`,
    desc: `Luôn đồng hành cũng các bạn tân sinh viên, sát cánh ngay những" bước đầu tiên". CLB Tin Học Sinh Viên hỗ trợ tân sinh viên trong việc khai báo hồ sơ, hoàn tất thủ tục nhập học bằng mọi hình thức dù xa hay gần chỉ với những click chuột. Bên cạnh đó, các kênh hỗ trợ online, tổng đài liên hệ luôn sẵn sàng để giải đáp thắc mặc cho tân sinh viên và phụ huynh.`,
    images: [ht1, ht2, ht3, ht4, ht5],
  },
];

export default events;
